import { offlineDb } from '@/db/offlineDb';
import { categoryOperationsService } from '@/services/categories/categoryOperations.service';
import { isValidUUID } from '@/utils/validation';
import { safeToastError } from '@/components/ui/toastManager';

export async function sanitizeQueueItemCategory(item: any): Promise<boolean> {
  const data = item?.data;
  if (!data) return true;

  const field = 'category_id' in data ? 'category_id' : 'category' in data ? 'category' : null;
  if (!field) return true;

  const value = data[field];
  if (!value || isValidUUID(value)) return true;

  try {
    const other = await categoryOperationsService.getOrCreateCategory('Altro');
    if (!other?.id) throw new Error('Invalid category_id');

    data[field] = other.id;
    await offlineDb.syncQueue.update(item.id!, { data });

    const store = (offlineDb as any)[item.entityType];
    if (store) {
      await store.update(item.entityId, { [field]: other.id });
    }

    return true;
  } catch (_error) {
    await offlineDb.syncQueue.update(item.id!, {
      status: 'failed',
      errorDetail: 'Invalid category_id'
    });
    safeToastError('Impossibile sincronizzare un elemento: categoria non valida');
    return false;
  }
}
